// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Card } from '@iheartjane/reefer';
import { mediaQueries, spacing } from '@iheartjane/reefer-emotion';

export const StyledCardGroup = styled(Card.Group)(({ theme }) => ({
  '&:hover': { borderColor: theme.colors.transparent.black.twenty },
}));

export const StyledCardContent = styled(Card.Content)({
  ...spacing({ p: 0 }),
});

export const StyledActionCardContent = styled(Card.Content)({
  ...spacing({ px: 24, pb: 24, pt: 0 }),
  height: 'auto',
  [mediaQueries.tablet('min')]: {
    ...spacing({ p: 24 }),
  },
});
